import { Typography } from '@breetometer/components';
import { type CURRENCYCODETYPE, CURRENCYCONFIG } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { IWithdrawalsProps } from '../DialogWithdrawalHistoryDetails.helpers';
import WithdrawalsAddress from './Withdrawals.Address';
import WithdrawalsNuban from './Withdrawals.Nuban';

const Withdrawals = ({ withdrawalHistoryData }: IWithdrawalsProps) => {
	const currencyOutput = useCurrencyOutput();

	const fiatConfig = CURRENCYCONFIG[withdrawalHistoryData.currency.toUpperCase() as CURRENCYCODETYPE];

	return (
		<>
			<div className='transactiondetails_header'>
				<Typography as='p'>WITHDRAWAL</Typography>
				<Typography as='h5'>
					{fiatConfig.symbol}
					{currencyOutput(withdrawalHistoryData.amount)}
				</Typography>
			</div>

			{withdrawalHistoryData.doc.meta.type === 'nuban' || withdrawalHistoryData.doc.meta.type === 'ghs_bank' ? (
				<WithdrawalsNuban withdrawalHistoryData={withdrawalHistoryData} />
			) : (
				<WithdrawalsAddress withdrawalHistoryData={withdrawalHistoryData} />
			)}
		</>
	);
};

export default Withdrawals;
